<div class="main-content__wrapper--centered">
    <div class="main-content__inner">
        <mat-icon
            class="riege-icon main-content__icon"
            svgIcon="scope-crying-specialist"
            alt="crying face emoji, 403"></mat-icon>

        <h2 i18n="@@notallowed-headline">Looks like you went off track.</h2>

        <p i18n="@@notallowed-description">You are not allowed to access this page.</p>

        <button class="riege-button" mat-flat-button color="primary" (click)="goHome()" i18n="@@button-label-gohome"
            >Go back to start</button
        >
    </div>
</div>
